import React from 'react'
import BenchmarkingContentRow from './BenchmarkingContentRow'

interface BenchmarkingPlaceholderProps {
  text: React.ReactNode
  title?: string
}

// Temporary placeholder for Beräkningsstöd-views that are scaffolded but not yet
// implemented. Reuses BenchmarkingContentRow so the layout matches real views.
const BenchmarkingPlaceholder = ({ text, title }: BenchmarkingPlaceholderProps) => (
  <BenchmarkingContentRow
    title={title}
    graph={
      <div className="flex h-full w-full items-center justify-center text-gray-400">
        <span style={{ fontSize: 18 }}>Vyn är under uppbyggnad</span>
      </div>
    }
    text={text}
  />
)

export default BenchmarkingPlaceholder
